module.exports = __webpack_public_path__ + "img/sj_daigang.b82a2302.jpg";